.input-container{background-color:#5a42d014}.input-container .caption{display:flex;justify-content:space-between}.input-container mat-form-field{background-color:#fff;width:100%}.attribute-value{color:#232426de}.clickable{cursor:pointer}
/*# sourceMappingURL=abstract-attribute-input-component.css.map */
